export type AppConfig = {
  chartApiBaseUrl: string | undefined;
  identityApiBaseUrl: string | undefined;
  patientApiBaseUrl: string | undefined;
  facilityApiBaseUrl: string | undefined;
  timerApiBaseUrl: string | undefined;
  orderApiBaseUrl: string | undefined;
  chartEngineApiBaseUrl: string | undefined;
  environment: string | undefined;
  nodeEnv: string;
  isDev: boolean;
  auth0Domain: string;
  auth0ClientId: string;
  auth0BackendApiAudience: string | undefined;
  auth0LogoutUrl: string | undefined;
  SLPatientApiBaseUrl: string | undefined;
  ipifyUrl: string | undefined;
  llmApiBaseUrl: string | undefined;
  openReplayProjectKey: string | undefined;
  openReplayIngestPoint: string | undefined;
};

type ConfigEnv = {
  REACT_APP_CHART_API_BASE_URL?: string;
  REACT_APP_IDENTITY_API_BASE_URL?: string;
  REACT_APP_PATIENT_API_BASE_URL?: string;
  REACT_APP_FACILITY_API_BASE_URL?: string;
  REACT_APP_TIMER_API_BASE_URL?: string;
  REACT_APP_ORDER_API_BASE_URL?: string;
  REACT_APP_CHART_ENGINE_API_BASE_URL?: string;
  REACT_APP_ENVIRONMENT?: string;
  REACT_APP_AUTH0_DOMAIN?: string;
  REACT_APP_AUTH0_CLIENT_ID?: string;
  REACT_APP_AUTH0_BACKEND_API_AUDIENCE?: string;
  REACT_APP_AUTH0_LOGOUT_URL?: string;
  REACT_APP_STP_VIP_API_BASE_URL?: string;
  REACT_APP_IPIFY_URL?: string;
  REACT_APP_LLM_BASE_URL?: string;
  REACT_APP_OPENREPLAY_PROJECT_KEY?: string;
  REACT_APP_OPENREPLAY_INGEST_POINT?: string;
  MODE?: string;
  DEV?: boolean;
};

export function readConfigValue(value: string | undefined): string | undefined {
  if (value === undefined || value === "" || value === "null") {
    return undefined;
  }

  return value;
}

export function createConfig(env: ConfigEnv): AppConfig {
  return {
    chartApiBaseUrl: env.REACT_APP_CHART_API_BASE_URL,
    identityApiBaseUrl: env.REACT_APP_IDENTITY_API_BASE_URL,
    patientApiBaseUrl: env.REACT_APP_PATIENT_API_BASE_URL,
    facilityApiBaseUrl: env.REACT_APP_FACILITY_API_BASE_URL,
    timerApiBaseUrl: env.REACT_APP_TIMER_API_BASE_URL,
    orderApiBaseUrl: env.REACT_APP_ORDER_API_BASE_URL,
    chartEngineApiBaseUrl: env.REACT_APP_CHART_ENGINE_API_BASE_URL,
    environment: env.REACT_APP_ENVIRONMENT,
    nodeEnv: env.MODE ?? "production",
    isDev: env.DEV === true || env.MODE === "development",
    auth0Domain: env.REACT_APP_AUTH0_DOMAIN || "",
    auth0ClientId: env.REACT_APP_AUTH0_CLIENT_ID || "",
    auth0BackendApiAudience: env.REACT_APP_AUTH0_BACKEND_API_AUDIENCE,
    auth0LogoutUrl: env.REACT_APP_AUTH0_LOGOUT_URL,
    SLPatientApiBaseUrl: env.REACT_APP_STP_VIP_API_BASE_URL,
    ipifyUrl: env.REACT_APP_IPIFY_URL,
    llmApiBaseUrl: env.REACT_APP_LLM_BASE_URL,
    openReplayProjectKey: env.REACT_APP_OPENREPLAY_PROJECT_KEY,
    openReplayIngestPoint: env.REACT_APP_OPENREPLAY_INGEST_POINT,
  };
}

export default createConfig(import.meta.env);
